module.exports = __webpack_public_path__ + "img/7.a9b4fb1d.gif";